let csrfToken = ''

export function setCsrfToken(value: string): void { csrfToken = value }

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function api<T>(url: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (options.body !== undefined && !(options.body instanceof FormData)) headers.set('content-type', 'application/json')
  if (options.method && options.method !== 'GET' && options.method !== 'HEAD') headers.set('x-csrf-token', csrfToken)
  const response = await fetch(url, { ...options, headers, credentials: 'same-origin' })
  if (!response.ok) {
    const payload = await response.json().catch(() => ({})) as { error?: string }
    if (response.status === 401 && url.startsWith('/api/admin/')) {
      window.dispatchEvent(new CustomEvent('kakim:unauthorized'))
    }
    throw new ApiError(payload.error || `Ошибка сервера (${response.status})`, response.status)
  }
  return response.json() as Promise<T>
}

export function messageFrom(error: unknown): string {
  return error instanceof Error ? error.message : 'Не удалось выполнить действие.'
}
